import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b2efce0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0b2efce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2efce0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoBg: require('/var/www/mbm.garena.all/frontend/components/home/HomeBanner/VideoBg.vue').default})
